import { DESKTOP_BREAKPOINT } from "@/lib/consts";
import { useEffect, useState } from "react";

export const useScreen = () => {
  const [isMobile, setIsMobile] = useState<boolean | null>(null);
  const [height, setHeight] = useState(0);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      const currentSize = window.innerWidth;
      if (currentSize < DESKTOP_BREAKPOINT) {
        setIsMobile(true);
      } else {
        setIsMobile(false);
      }
      setHeight(window.innerHeight);
      setWidth(window.innerWidth);
    };

    // set initial state
    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
    isDesktop: isMobile === null ? null : !isMobile,
    height,
    width,
  };
};
